import React from 'react';
import { Page } from '../Page';
import { CheckCircle2Icon, AlertTriangleIcon, ShieldCheckIcon } from 'lucide-react';
export function Page6() {
  const deficiencies = [{
    title: 'Fatigue',
    items: 'Folate (B9), B12, Vitamin D, Iron'
  }, {
    title: 'Hair Loss',
    items: 'Biotin (B7), Iron, Zinc'
  }, {
    title: 'Depression',
    items: 'B6, Folate (B9), Vitamin D, Iron'
  }, {
    title: 'Poor Sleep',
    items: 'Vitamin D, Iron, Magnesium'
  }];
  const vitamins = ['Vitamin A', 'Vitamin C', 'Vitamin D', 'Vitamin E', 'Vitamin K', 'Vitamin B1', 'Vitamin B2', 'Vitamin B3', 'Vitamin B5', 'Vitamin B6', 'Vitamin B7', 'Vitamin B9', 'Vitamin B12', 'Iron', 'Zinc'];
  return <Page pageNumber={12} variant="light" data-id="element-800">
      <div className="flex flex-col h-full" data-id="element-801">
        <div className="h-[160px] -mx-12 -mt-10 mb-8 overflow-hidden relative" data-id="element-802">
          <img src="https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=1000&q=80" alt="Vitamins and supplements" className="w-full h-full object-cover object-center" data-id="element-803" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#F5F5F0] via-transparent to-transparent" data-id="element-804" />
        </div>

        <div className="mb-8" data-id="element-805">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-806">
            The Essentials
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-807">
            Vitamins <span className="text-tealslate" data-id="element-808">&</span> Minerals
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-809" />
        </div>

        <div className="grid grid-cols-2 gap-10 mb-8" data-id="element-810">
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-811">
            People on GLP-1 medications eat much less due to reduced appetite.
            This makes it difficult to meet vitamin and mineral needs through
            food alone. A daily multivitamin acts as nutritional insurance.
          </p>
          <div data-id="element-812">
            <h3 className="text-sm font-bold text-[#1F1F1F] mb-3 flex items-center gap-2" data-id="element-813">
              <AlertTriangleIcon className="w-4 h-4 text-[#C4956A]" data-id="element-814" />
              Potential Deficiencies
            </h3>
            <div className="grid grid-cols-2 gap-2" data-id="element-815">
              {deficiencies.map((def, idx) => <div key={idx} className="bg-tealslate/10 p-2.5 border border-tealslate/20" data-id="element-816">
                  <span className="font-bold text-[#1F1F1F] text-xs" data-id="element-817">
                    {def.title}
                  </span>
                  <p className="text-[10px] text-[#7A7A70] mt-0.5" data-id="element-818">
                    {def.items}
                  </p>
                </div>)}
            </div>
          </div>
        </div>

        <h2 className="text-lg font-serif text-[#1F1F1F] mb-3" data-id="element-819">
          What Should Your Multivitamin Have?
        </h2>
        <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 mb-6" data-id="element-820">
          <div className="grid grid-cols-3 gap-y-2" data-id="element-821">
            {vitamins.map((v, idx) => <div key={idx} className="flex items-center gap-2" data-id="element-822">
                <CheckCircle2Icon className="w-3.5 h-3.5 text-tealslate shrink-0" data-id="element-823" />
                <span className="text-[#3B3B3B] text-xs" data-id="element-824">{v}</span>
              </div>)}
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4" data-id="element-825">
          <div className="bg-white border border-[#D8D8D0] p-4" data-id="element-826">
            <h3 className="font-bold text-[#1F1F1F] text-sm mb-2" data-id="element-827">
              Pick a Form You'll Take
            </h3>
            <div className="flex gap-2 mb-2" data-id="element-828">
              {['Tablet', 'Gummy', 'Liquid'].map((f, i) => <span key={i} className="bg-tealslate/15 text-tealslate px-3 py-1 text-[10px] font-bold" data-id="element-829">
                  {f}
                </span>)}
            </div>
            <p className="text-[10px] text-[#7A7A70]" data-id="element-830">
              Consistency is more important than form. Gummy and liquid forms
              are less likely to contain iron.
            </p>
          </div>
          <div className="bg-tealslate/10 border border-tealslate/20 p-4 flex flex-col justify-center" data-id="element-831">
            <div className="flex items-center gap-2 mb-2" data-id="element-832">
              <ShieldCheckIcon className="w-5 h-5 text-tealslate" data-id="element-833" />
              <h3 className="font-bold text-[#1F1F1F] text-sm" data-id="element-834">
                Third-Party Tested
              </h3>
            </div>
            <p className="text-[10px] text-[#3B3B3B]" data-id="element-835">
              Choose supplements certified by USP or NSF for safety and quality.
            </p>
          </div>
        </div>
      </div>
    </Page>;
}